import { api } from "../../lib/api";
import type { Position } from "../portfolio/api";

export type TxnType = "buy" | "sell" | "dividend" | "deposit" | "withdrawal" | "fee" | "split";
export type TxnStatus = "confirmed" | "pending" | "cancelled";

export interface Transaction {
  id: string;
  portfolioId: string;
  securityId: string | null;
  sgiId: string | null;
  type: TxnType;
  status: TxnStatus;
  tradeDate: string;
  settlementDate: string | null;
  quantity: string;
  unitPrice: string;
  commissionSgi: string;
  brvmFees: string;
  otherFees: string;
  taxAmount: string;
  totalFees: string;
  cashEffect: string;
  currency: string;
  notes: string | null;
  externalRef: string | null;
  reversesTxnId: string | null;
  createdAt: string;
}

export interface Security {
  id: string;
  ticker: string;
  isin: string | null;
  name: string;
  type: string;
  sector: string | null;
  currency: string;
  status: string;
  /** Bonds: prix unitaire d'acquisition. */
  face_value: string | null;
  /** Bonds: annual nominal rate, in percent. */
  nominal_rate: string | null;
  /** Bonds: lifetime in months. */
  duration_months: number | null;
  latest_close: string | null;
  previous_close: string | null;
  price_date: string | null;
}

export interface NewTransactionInput {
  type: TxnType;
  securityId?: string;
  tradeDate: string;
  quantity: string;
  unitPrice: string;
  commissionSgi?: string;
  brvmFees?: string;
  otherFees?: string;
  taxAmount?: string;
  notes?: string;
}

export const listTransactions = (portfolioId: string) =>
  api<{ data: Transaction[]; nextCursor: string | null }>(
    `/portfolios/${portfolioId}/transactions`,
  ).then((r) => r.data);

export const createTransaction = (portfolioId: string, input: NewTransactionInput) =>
  api<{ transaction: Transaction; position: Position | null }>(
    `/portfolios/${portfolioId}/transactions`,
    { method: "POST", body: input },
  );

export const cancelTransaction = (id: string) =>
  api<{ transaction: Transaction; position: Position | null }>(`/transactions/${id}/cancel`, {
    method: "POST",
  });

export const searchSecurities = (q: string, types?: string[]) =>
  api<{ data: Security[] }>(
    `/securities?q=${encodeURIComponent(q)}&limit=20` +
      (types?.length ? `&types=${types.join(",")}` : ""),
  ).then((r) => r.data);
